module.exports = __webpack_public_path__ + "src/assets/img/photo_seraphim1.014062a6.jpg";